import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { StreamMetrics } from "@/components/business/StreamMetrics";
import { RoyaltySplitCalculator } from "@/components/business/RoyaltySplitCalculator";

export const TheBusiness = () => {
  const [streamData, setStreamData] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const streamsRes = await axios.get(`${API}/analytics/streams`);
      setStreamData(streamsRes.data);
    } catch (error) {
      console.error("Failed to fetch business data:", error);
    }
  };

  const handleCalculateSplit = async (amount, artistPercent) => {
    try {
      const response = await axios.post(
        `${API}/analytics/calculate-split?total_amount=${amount}&artist_percent=${artistPercent}`
      );
      return response.data;
    } catch (error) {
      console.error("Failed to calculate split:", error);
      return null;
    }
  };

  return (
    <div className="space-y-6" data-testid="the-business-page">
      {/* Page Header */}
      <header className="mb-8">
        <h1 className="font-sans font-black text-4xl text-meta-text tracking-tight">
          The Business
        </h1>
        <p className="text-meta-text-secondary mt-1">
          Analytics & Distribution
        </p>
      </header>

      {/* Stream Metrics Grid */}
      <StreamMetrics platforms={streamData?.platforms || []} />

      {/* Royalty Split Calculator - Full Width */}
      <RoyaltySplitCalculator onCalculate={handleCalculateSplit} />
    </div>
  );
};

export default TheBusiness;
